import * as React from "react";
import { forwardRef } from "react";
const SvgSleep = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 50", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", d: "M5 8c.333-1 1-2 1-3S5 4 5 3s.333-1.333 1-2", className: "pathClass" }));
const ForwardRef = forwardRef(SvgSleep);
export default ForwardRef;
